import { createSlice } from "@reduxjs/toolkit";
import { UserDataType } from "@/types/global";

export interface initLoginState {
  token?: string;
  nonAuthToken?: string;
  user?: UserDataType;
  referralCode?: string;
}

const initLoginState: initLoginState = {
  token: undefined,
  // token:
  //   "eyJhbGciOiJIUzI1NiJ9.NDU2MTIxMjBhNzEzNzgzNWM1Y2Y5MTIxZjllZDgyNGY6ZTlmYThmM2ZmM2IwZGM2NmJiY2YwNDNkNDg0OTg3NjY1ZmUwODg4MWZmMzk2ZWUyNGNkMmY0MmJkODIyMzUyNzAzNWI0NzljZGYyOWRhMGIxOWZjY2NiYmUwMmQ0OGIzZTkyNjVkMjE0YzIzZWY5ZjVjYTExOTNlZWEzNmMzYzk1NmZmNTQ2MjEyNThhYTcxZjgyZTdhMTM0NTY5MGZlN2Q1YWVjMWYzNDYyMmZlM2ZkZDk5NTIyOWFmMGRhNzBmYTFhYjhlNDgwNzY1NDYxZGZiYjUwMzcxZjFhMDZmNWY3NTVkODdkYzMwNmExNmNiOWNhNmM3YzdlOGJlZTAwOTFiN2JmYmI5Y2VjMmExN2M0MTc3NDgzNzEyMWQ4ZmU0NThlZjA0OTU2NDI3NTFkNzFmZGRiNjk1OTc3OGNjN2E1NTMwYTQ0OWJlYmU4MTkwM2E4NmM2YTU0ZGEzYzk5MzQ3ODZjODYyNzY5MjJkNDYyZGE1MTg3N2IyMTJlMzQ0YTM0Njc2ZjhlMzdlNGIyMGQ3NTA3YzZhN2Q2Mzc5YzQ0OWZkYzAwZjM4NmExMTRkNGY4ZWY0YWEyODE0NzNkYmFmN2FhMmM4OGViOTY0NDUzMGVhZmYzYmE0NWMzOGQ5MDg1NDVmOTJkZjViYTRhNTMxMzYzMWZmZGU4MjlmMDNhNDY1NmUzM2Q1OWM3NWM1ZTljZjViYmYzMmZlZTZkM2I3ZTU2MmVhNmUxMDczOTBjYzNlYmU3MjdiMTkzMWExZGM3OTY4ZGEyZjhmNzEzZmZjYjNmYmYxNDkwYTE3YmI3NTNmYmRjNzRhN2FhYzZkMGM0MWFjMWFkNWFkNzg3YWViNGJkNmIzZGQ2YmZjYWI0YzIyZDhmNGZlMzNhMWUyNTc1NTA1Zjk4NDJiZjM5ZmQxZjNkMGExNWI5MTk3Mjc4N2Q4OWJjNGI1MzdjZWRiNjNjMjZjNDE0OWE0MDUwNWE0ZWU4Njc3ZjI5ZmRkODJhNzU0NDQ3ZmZlYmJlMmVhMTZhY2JlZWZhNmIzODc4MzJiOGNhMTNmN2U4YTQ4ZmExYTViZWY5ZjI3YjkzZjBiODBmMmNjYWU3Mzg1ZTFjZGRmNjExMDcwYWM5ZTU2YWFiMmYwNGEyMmZmMjhlZmZmNTYxYmEyZDdkNGFlY2NmNWFlY2JlYjA2NmMyNmM2YmY3OTU1ZTM0NjgxMGMyZjVlN2RjMTljNmMwNzE0NGZhMWQ0MzQ1NWFkZTVjZWJmZmMyNDcwNWE2Y2FlZTU1YjYzOTMyYTlhYzJjMGI3ZmU5YmE0ZGNhYjc3NTRhY2FmMTcxMTYyODc2NjIxMTAxMzM2YWZkOGE3MWNlNWU0ZTYyNDY2M2QyYzFlYjBmYmM3NDQ2OGFjZTA5ZDU1ODA1ZGU5.x-drbhkSe20EWACGCGcpyu-ikCtYjSlbBKX8FcwflhA",
  user: undefined,
  referralCode: undefined,
  nonAuthToken: undefined,
};
const authReducer = createSlice({
  name: "auth",
  initialState: initLoginState,
  reducers: {
    login: (loginState, action) => {
      const { token, user } = action.payload;
      return {
        ...loginState,
        token,
        user,
      };
    },
    setUser: (loginState, action) => {
      const user = action.payload;
      return {
        ...loginState,
        user,
      };
    },
    logout: (loginState) => {
      return { ...loginState, token: undefined, user: undefined };
    },
    setReferralCode: (loginState, action) => {
      const code = action.payload;
      return {
        ...loginState,
        referralCode: code,
      };
    },
    setNonAuthToken: (loginState, action) => {
      const token = action.payload;
      return {
        ...loginState,
        nonAuthToken: token,
      };
    },
    resetReferralCode: (loginState, action) => {
      const code = action.payload;
      return {
        ...loginState,
        referralCode: undefined,
      };
    },
  },
});

export const {
  login,
  logout,
  setUser,
  setReferralCode,
  setNonAuthToken,
  resetReferralCode,
} = authReducer.actions;
// export default reducer;
export default authReducer.reducer;
